import { Controller } from '@hotwired/stimulus'
import SignaturePad from 'signature_pad'
import trimCanvas from "../libs/trim_canvas"
export default class extends Controller {
  static targets = ['canvas', 'clearButton', 'saveButton', "form"]

  connect() {
    this.initializes()
      // 监听表单提交完成事件
      // this.formTarget.addEventListener('turbo:submit-end', (event) => {
      //   // const response = event.detail.fetchResponse
      //   event.detail.fetchResponse.response.json().then(data => {
      //     console.log(data["errors"])
      //   }).catch(() => {
      //     console.log("error")
      //   })
      //   // const response = event.detail.fetchResponse
      //   // if (response) {
      //   //   response.json().then((data) => {
      //   //     if (!response.ok) {
      //   //       // 显示错误信息
      //   //       alert(data.error || '提交失败，请重试')
      //   //     }
      //   //   }).catch(() => {
      //   //     alert('提交失败，请重试')
      //   //   })
      //   // }
      // }, { once: true })
  }

  initializes() {
    this.signaturePad = new SignaturePad(this.canvasTarget, {
      backgroundColor: 'rgba(0, 0, 0, 0)',
      penColor: 'rgb(0, 0, 0)'
    })

    // 调整canvas大小以适应容器
    this.resizeCanvas()
    window.addEventListener('resize', this.resizeCanvas.bind(this))
  }

  resizeCanvas() {
    const canvas = this.canvasTarget
    const ratio = Math.max(window.devicePixelRatio || 1, 1)
    canvas.width = canvas.offsetWidth * ratio
    canvas.height = canvas.offsetHeight * ratio
    canvas.getContext('2d').scale(ratio, ratio)
    this.signaturePad.clear() // 清除之前的签名
  }

  clear() {
    this.signaturePad.clear()
  }

  cropSVG(svgText) {
    // First convert the svg string into an html element so we can
    // call getBBox() on it.
    const tempElement = document.createElement('div');
    tempElement.setAttribute('style', 'visibility: hidden');
    // getBBox() only works if the element is rendered into the page.
    document.body.appendChild(tempElement);
    tempElement.innerHTML = svgText;
    const svgElement = tempElement.getElementsByTagName('svg')[0]
    // This gets the bounding box around the signature.
    const bbox = svgElement.getBBox();
    // Use the bounding box's coordinates as the svg's viewBox.
    // This eliminates the whitespace by "zooming in" on the
    // bounding box.  Include 5px extra, as the signature's
    // edges get slightly clipped otherwise.
    const viewBox = [bbox.x - 5, bbox.y - 5, bbox.width + 10, bbox.height + 10].join(" ");
    svgElement.setAttribute("viewBox", viewBox);
    // Let the svg have the size and aspect ratio of the
    // cropped result, not the original canvas.
    svgElement.removeAttribute("width");
    svgElement.removeAttribute("height");
    const croppedSVG = svgElement.outerHTML;
    document.body.removeChild(tempElement);
    return croppedSVG;
  }

  trim() {
     // copy the canvas
     let copy = document.createElement('canvas')
     copy.width = this.canvasTarget.width
     copy.height = this.canvasTarget.height
     copy.getContext('2d').drawImage(this.canvasTarget, 0, 0)
     // then trim it
     return trimCanvas(copy)
  }

  save() {
    if (this.signaturePad.isEmpty()) {
      alert('请先签名')
      return
    }
    const dataURL = this.signaturePad.toDataURL('image/png')
    // 这里可以添加保存签名的逻辑，比如发送到服务器或保存到隐藏的input字段
    console.log('签名已保存:', dataURL)
    this.submitForm()
  }

  submitForm() {
    const signatureInput = document.getElementById('course_attendance_signature_data')
    if (signatureInput) {
      signatureInput.value = this.signaturePad.toDataURL('image/png')
      this.formTarget.requestSubmit()
    }
  }

  submit(event) {
    const response = event.detail.fetchResponse.response
    if (response) {
      response.json().then((data) => {
        if (!response.ok) {
          // 显示错误信息
          alert(data.errors || '提交失败，请重试')
        } else {
          // 提交成功，显示成功提示
          alert('提交成功')
          Turbo.visit(data.url || "/")
        }
      }).catch(() => {
        alert('提交失败，请重试')
      })
    }
  }

  saveto() {
    if (this.s.isEmpty()) {
      alert('请先签名')
      return
    }

    // 创建临时canvas并设置较小的尺寸
    const tempCanvas = document.createElement('canvas')
    const ctx = tempCanvas.getContext('2d')
    const maxWidth = 400 // 设置最大宽度
    const maxHeight = 300 // 设置最大高度
    const ratio = Math.min(maxWidth / this.canvasTarget.width, maxHeight / this.canvasTarget.height)
    tempCanvas.width = this.canvasTarget.width * ratio
    tempCanvas.height = this.canvasTarget.height * ratio

    // 绘制原始canvas内容到临时canvas
    ctx.drawImage(this.canvasTarget, 0, 0, tempCanvas.width, tempCanvas.height)

    const croppedSVGString = this.cropSVG(this.s.toSVG())
    // 使用临时canvas导出图片，并设置较低的图片质量
    const dataURL = tempCanvas.toDataURL('image/png', 0.7)
    // 这里可以添加保存签名的逻辑，比如发送到服务器或保存到隐藏的input字段
    console.log('签名已保存:', dataURL)
    console.log('签名已保存croppedSVGString:', croppedSVGString)
  }

  disconnect() {
    window.removeEventListener('resize', this.resizeCanvas.bind(this))
  }
}
